import { useState } from "react";
import { useDarkMode } from "../../context/DarkModeContext";
import { users } from "../../assets/DemoData";
import {
  InternalContainer,
  ExternalContainer,
} from "../../components/Reusable/Layout";
import { UserDetailModal } from "../../components/userManagement/userDetailModal";
import { UsersTable, UserSearchFilter } from "./component";
import { fetchUsers, fetchFilterOptions, setFilters } from "../../features/auth/store/userSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { useEffect, useCallback } from "react";

const UserManagement = () => {
  const darkMode = useDarkMode();
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number>(0);

  const handleUserClick = (user: any) => {
    setSelectedUser(user);
    setIsModalOpen(true);
    setSelectedUserId(user.user_id);
  };

 const handleFilterChange = (field: string, value: string) => {
    const newFilters = { [field]: value };
    dispatch(setFilters(newFilters));
    
    // Fetch users with updated filters
    dispatch(fetchUsers({ ...filters, ...newFilters, page: 1 }));
  };

  const dispatch = useAppDispatch();
  const { 
    users, 
    loading, 
    error, 
    total, 
    perPage, 
    currentPage, 
    lastPage, 
    filters,
    filterOptions 
  } = useAppSelector((state) => state.users);


// Fetch initial data
  useEffect(() => {
    dispatch(fetchUsers({ page: 1 }));
    dispatch(fetchFilterOptions());
  }, [dispatch]);

  // Handle pagination
  const handlePageChange = (newPage: number) => {
    if (!loading && newPage >= 1 && newPage <= lastPage) {
      dispatch(fetchUsers({ ...filters, page: newPage }));
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  // Show error state
  if (error) {
    return (
      <ExternalContainer>
        <div className="h-screen w-[1030px]">
          <InternalContainer headerText="User Management">
            <div className="flex items-center justify-center h-64">
              <div className="text-center">
                <p className="text-red-500 text-lg mb-4">Error loading users</p>
                <p className="text-gray-500 mb-4">{error}</p>
                <button
                  onClick={() => dispatch(fetchUsers({ page: 1 }))}
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
                >
                  Retry
                </button>
              </div>
            </div>
          </InternalContainer>
        </div>
      </ExternalContainer>
    );
  }
  return (
    <ExternalContainer>
      <div className="h-screen w-[1030px]">
        <InternalContainer headerText="User Management">
          <div className="flex flex-col">
            <UserSearchFilter 
              onFilterChange={handleFilterChange}
              filters={filters}
              filterOptions={filterOptions}
              loading={loading}
            />
            <div className="border border-[#FFFFFF1A]">
            <UsersTable
                users={users}
                onUserClick={handleUserClick}
                loading={loading}
                currentPage={currentPage}
                totalPages={lastPage}
                onPageChange={handlePageChange}
                total={total}
                perPage={perPage}
              />
            </div>
          </div>
        </InternalContainer>
      </div>
      {selectedUser && (
        <UserDetailModal
          userId={selectedUserId}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          showTabs={true}
          tabItems={["Personal Information", "Gamer Tags", "Purchases"]}
        />
      )}
    </ExternalContainer>
  );
};

export default UserManagement;
